export default __webpack_public_path__ + "static/media/k3.8d604204.jpg";